import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';
import { CluePostRequest, CluePostResponse } from 'types/clue';

import type { AreaStatus } from 'types/spot';

type State = {
  isInitialize: boolean;
  clue: string;
  result: boolean;
  clueNo?: number;
  areaStatus?: AreaStatus;
};

const initialState: State = {
  clue: '',
  isInitialize: false,
  result: false,
};

const apiKey = process.env.REACT_APP_API_KEY || '';
const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

// RTK Queryの設定
export const clueDataApi = createApi({
  reducerPath: 'clueDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('x-api-key', apiKey);
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['Clue'],
  endpoints: builder => ({
    sendClueData: builder.mutation<CluePostResponse, CluePostRequest>({
      query: ({ password, area }) => ({
        url: `/clue?area=${area}`,
        method: 'POST',
        body: { password },
      }),
      invalidatesTags: ['Clue'],
    }),
  }),
});

// エンドポイント毎にカスタムhooksが作成される
export const { useSendClueDataMutation } = clueDataApi;

const clue = createSlice({
  name: 'clue',

  initialState,

  reducers: {
    updateClue: (state, action: PayloadAction<string>) => {
      state.clue = action.payload;
    },
    updateAreaStatus: (state, action: PayloadAction<AreaStatus>) => {
      state.areaStatus = action.payload;
    },
  },

  extraReducers: builder => {
    // POST後に状態を取得
    builder.addMatcher(
      clueDataApi.endpoints.sendClueData.matchFulfilled,
      (state, action: PayloadAction<CluePostResponse>) => {
        console.log('POST clue fulfilled');

        const { result, clueNo, areaStatus } = action.payload;

        return {
          ...state,
          result,
          clueNo,
          areaStatus,
          isInitialize: true,
        };
      }
    );
    // POST失敗
    builder.addMatcher(clueDataApi.endpoints.sendClueData.matchRejected, state => {
      console.error('POST clue rejected');
    });
  },
});

// Action Creators
export const { updateClue, updateAreaStatus } = clue.actions;

// Reducer
export default clue.reducer;
